import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { db } from '../../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import InstructorAssignmentsView from '../../components/dashboard/InstructorAssignmentsView';
import { Loader2 } from 'lucide-react';

export default function InstructorAssignments() {
  const { currentUser } = useAuth();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const coursesQ = query(collection(db, 'courses'), where('instructorId', '==', currentUser.uid));
        const coursesSnap = await getDocs(coursesQ);
        setCourses(coursesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        console.error("Error fetching courses:", err);
      } finally {
        setLoading(false);
      }
    };
    if (currentUser) fetchCourses();
  }, [currentUser]);

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="w-10 h-10 animate-spin text-amber-500" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Title / Description */}
      <div>
        <h1 className="text-3xl font-black text-slate-900 dark:text-white mb-2 tracking-tight">إدارة التكاليف</h1>
        <p className="text-slate-500 dark:text-zinc-400 font-medium">راجع وقيّم تكاليف ومشاريع الطلاب المشتركين في دوراتك.</p>
      </div>

      <InstructorAssignmentsView myCourses={courses} />
    </div>
  );
}
